import { useState } from 'react'
import { useRouter } from 'next/router'
import { Row, Col, Form, Input, Button, message, Space, Alert } from 'antd'
import Link from 'next/link'
import styles from '../../styles/login.module.css'
import { withAuth, Type } from '../../providers/auth'
import Consts from '../../configs/consts'

function Login({ AuthStore }) {
  const router = useRouter()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [userDisabled, setUserDisabled] = useState(false)

  const handleSubmit = async (values) => {
    try {
      setLoading(true)
      const { id, password } = values
      await AuthStore.login(id, password)

      // 初回ログイン時にパスワードの更新が必要な場合
      if (AuthStore.needsToCompleteNewPassword()) {
        await router.push('/login/new')
        return
      }

      // 認証アプリによるコードの入力が必要な場合
      if (AuthStore.needsToVerifyTotp()) {
        await router.push('/login/totp', '/login/totp', { query: { next: router.query.next } })
        return
      }

      // 2段階認証の設定が必要な場合
      if (await AuthStore.needsToSetupMfa()) {
        await router.push('/login/setupMfa')
        return
      }

      if (router.query.next) {
        await router.push(router.query.next)
      } else {
        await router.push('/dashboard')
      }
    } catch (error) {
      if (error.message === 'RegistrationUncompleteError') {
        if (AuthStore.needsToCompleteNewPassword()) {
          await router.push('/signup/organization?skip=true')
        } else {
          await router.push('/signup/license')
        }
        return
      }
      if (error.message === 'このアカウントは無効になっています') {
        message.destroy()
        setUserDisabled(true)
        return
      }
      message.destroy()
      message.error(error.message)
      console.warn(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>{Consts.ServiceName}</h1>
        <Form form={form} layout="vertical" requiredMark={false} onFinish={handleSubmit}>
          <Row type="flex" justify="center" align="middle">
            <Col xs={24} sm={18} md={14} lg={10} xl={8}>
              {AuthStore.expired && (
                <Alert className={styles.alert} style={{ marginTop: 16 }} message="セッションの有効期限が切れました。" type="warning" showIcon />
              )}
              {userDisabled && (
                <Alert
                  message="一時的にアカウントを停止させていただいております。ご利用再開のお手続きについてはサポートにお問い合わせください。"
                  type="warning"
                  showIcon
                  style={{ marginTop: 16 }}
                />
              )}
              <div className={styles.formContainer}>
                <Form.Item name="id" rules={[{ required: true, message: 'メールアドレスを入力してください' }]}>
                  <Input size="large" type="email" placeholder="メールアドレス" />
                </Form.Item>
                <Form.Item name="password" rules={[{ required: true, message: 'パスワードを入力してください' }]}>
                  <Input type="password" size="large" placeholder="パスワード" />
                </Form.Item>
                <Button type="primary" htmlType="submit" size="large" block loading={loading} className={styles.loginButton}>
                  ログイン
                </Button>
              </div>
              <div className={styles.link}>
                <Link href="/signup">新規登録はこちら</Link>
              </div>
              <div className={styles.link}>
                <Link href="/login/reset">パスワードをお忘れの方はこちら</Link>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}

export default withAuth(Login, Type.NotProtected)
